<template>
  <div class="col-md-8 mx-auto mt-3 px-0">
    <error-banner v-if="error" :message="error"/>
    <fieldset v-bind:disabled="contractCompleted">
      <label for="signature" class="font-weight-bold">
        Review and sign the contract below:
      </label>
      <canvas ref="signatureCanvas" id="ContractSignature"/>
      <validation-message v-if="validator.signatureError" :message="validator.signatureError"/>
      <button @click="clear" class="btn btn-primary mt-2">Clear</button>
    </fieldset>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { ClientCacheMixin } from '../../../mixins/Registration/ClientCacheMixin'
import { SignatureAddMixin } from '@/mixins/Registration/SignatureAddMixin'
import { ClientOnboardingInviteCacheMixin } from '../../../mixins/Registration/ClientOnboardingInviteCacheMixin'
import ErrorBanner from '../../ErrorValidation/ErrorBanner.vue'
import ValidationMessage from '@/components/ErrorValidation/ValidationMessage.vue'
import SignaturePad from 'signature_pad'

export default {
  name: 'SignaturePad',
  mixins: [ClientCacheMixin, SignatureAddMixin, ClientOnboardingInviteCacheMixin],
  data () {
    return {
      pad: null,
      handleEndStroke: null,
      resizeObserver: null
    }
  },
  computed: {
    ...mapState('ApplicationEvents', [
      'saveRegistrationEvent'
    ]),
    clientFullName () {
      return `${this.clientCache?.firstName ?? ''} ${this.clientCache?.lastName ?? ''}`.trim()
    }
  },
  watch: {
    saveRegistrationEvent () {
      this.handleUpdateEvent()
    },
    acceptMarketingUpdated () {
      this.handleUpdateEvent()
    }
  },
  methods: {
    ...mapMutations('ClientOnboardingInvites', [
      'setContractCompleted'
    ]),
    afterAddSignature () {
      this.setContractCompleted()
    },
    handleUpdateEvent () {
      if (!this.contractCompleted && this.acceptMarketingUpdated) {
        this.tryAddSignature()
      }
    },
    clear () {
      this.pad.clear()
      this.signedText = ''
    },
    resizeCanvas () {
      const canvas = this.$refs.signatureCanvas
      if (!canvas || !canvas.offsetWidth || !canvas.offsetHeight) {
        return
      }
      const ratio = Math.max(window.devicePixelRatio || 1, 1)
      canvas.width = canvas.offsetWidth * ratio
      canvas.height = canvas.offsetHeight * ratio
      canvas.getContext('2d').scale(ratio, ratio)
      if (this.pad) {
        this.pad.clear()
        this.signedText = ''
      }
    }
  },
  mounted () {
    const canvas = this.$refs.signatureCanvas
    this.pad = new SignaturePad(canvas)
    this.handleEndStroke = () => {
      this.signedText = this.pad.toDataURL()
    }
    this.pad.addEventListener('endStroke', this.handleEndStroke)
    this.resizeCanvas()
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => this.resizeCanvas())
      this.resizeObserver.observe(canvas)
    } else {
      window.addEventListener('resize', this.resizeCanvas)
    }
  },
  beforeDestroy () {
    if (this.pad && this.handleEndStroke) {
      this.pad.removeEventListener('endStroke', this.handleEndStroke)
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    } else {
      window.removeEventListener('resize', this.resizeCanvas)
    }
  },
  components: {
    'error-banner': ErrorBanner,
    'validation-message': ValidationMessage
  }
}
</script>

<style scoped>
#ContractSignature{
  background: #FFEDB2;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  height: 12rem;
  width: 100%;
}
@media screen and (max-width: 768px)  {
  #ContractSignature{
    height: 10rem;
    width: 100%;
  }
}
</style>
